import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { UserSessionService, PatientParms } from '../../shared';
import { ModalService } from '../../blocks';
import { ServiceHistoryComponent } from '../../orders/service-history/service-history.component';
import { EmrPatAllVisitsComponent } from '../../medical-recored/emr-pat-all-visits/emr-pat-all-visits.component';

@Component({
    selector: 'call-data-pat-visits-services',
    templateUrl: './call-data-pat-visits-services.component.html',
})

export class CallDataPatVisitsServicesComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    patientParms: PatientParms;
    showPatServices: boolean;
    patCode: number;
    @ViewChild(EmrPatAllVisitsComponent, { static: true }) emrPatAllVisitsComponent: EmrPatAllVisitsComponent;
    @ViewChild(ServiceHistoryComponent, { static: true }) serviceHistoryComponent: ServiceHistoryComponent;


    constructor(
        public translate: TranslateService,
        private _userSessionService: UserSessionService,
        private _modalService: ModalService
    ) { }


    ngOnInit() {
        this._userSessionService.subscribeToKey$('patientCallCenter')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {

                if (keys.value) {
                    this.patCode = keys.value.patCode;
                    this.getVisitsHistory(keys.value)
                }
                else {
                    this.showPatServices = false;
                    this.getVisitsHistory(null)
                }
            });

    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    getVisitsHistory(PatientParms: any) {
        this.emrPatAllVisitsComponent.getAllData(PatientParms)
    }

    getPatServices(visit) {
        if (visit) {
            this.showPatServices = true
            this.patientParms = visit;
            this.patientParms.patCode = this.patCode
            this.patientParms.visitSerial = visit.visitSerial;
            this._userSessionService.setSessionKey("PatParmsFromCallData", this.patientParms)
            this.serviceHistoryComponent.getPatParmsFromCallData()
        }

        else {
            this.showPatServices = false
        }
    }


}



